<div class="row filter-type-selection-header"></div>
<div class="row">
  <div class="col-6">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(yearOfIncorporationFrom) }">
      <span class="ey-float-label">
        <select
          class="form-control form-select"
          id="yearOfIncorporationFrom"
          name="yearOfIncorporationFrom"
          [(ngModel)]="filter.onAndAfter"
          [appRequiredIf]="!filter.upToAndIncluding"
          [disabled]="readOnly"
          #yearOfIncorporationFrom="ngModel"
          (click)="formDirty = true"
          appLabelFloat
        >
          <option [value]="undefined" selected></option>
          <option *ngFor="let yr of yearOfIncorporationOptions" [ngValue]="yr">{{ yr }}</option>
        </select>
        <label>From</label>
      </span>
      <span class="help-block">
        <input type="hidden" [(ngModel)]="filter.onAndAfter" name="onAndAfter" #onAndAfter="ngModel" required />
        <span
          *ngIf="
            formDirty &&
            ShowValidationMessage(yearOfIncorporationFrom) &&
            yearOfIncorporationFrom.errors?.requiredIf &&
            yearOfIncorporationTo.errors?.requiredIf
          "
        >
          Please select a value for From, To, or both
        </span>
      </span>
    </div>
  </div>
  <div class="col-6">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(yearOfIncorporationTo) }">
      <span class="ey-float-label">
        <select
          class="form-control form-select"
          id="yearOfIncorporationTo"
          name="yearOfIncorporationTo"
          [(ngModel)]="filter.upToAndIncluding"
          [appRequiredIf]="!filter.onAndAfter"
          [disabled]="readOnly"
          #yearOfIncorporationTo="ngModel"
          (click)="formDirty = true"
          appLabelFloat
        >
          <option [value]="undefined" selected></option>
          <option *ngFor="let yr of yearOfIncorporationOptions" [ngValue]="yr">{{ yr }}</option>
        </select>
        <label>To</label>
      </span>
      <span class="help-block">
        <input type="hidden" [(ngModel)]="filter.upToAndIncluding" name="upToAndIncluding" #upToAndIncluding="ngModel" required />
        <span *ngIf="formDirty && !CheckEndGreaterThanBeginning(filter.onAndAfter, filter.upToAndIncluding)"> To must be greater than From </span>
      </span>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <p-checkbox
      id="includeYearNotKnown"
      name="includeYearNotKnown"
      [(ngModel)]="filter.includeYearNotKnown"
      [disabled]="readOnly || disablePassIfNa"
      binary="true"
    ></p-checkbox>
    <label for="includeYearNotKnown">Include companies with unknown Year of Incorporation</label>
  </div>
</div>
